import { Component, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ScreenService } from 'src/app/common/services/screen.service';
import { SafeBoxEditComponent } from '../safe-box-edit/safe-box-edit.component';
import { SafeBoxImportComponent } from '../safe-box-import/safe-box-import.component';
import { MatIconModule } from '@angular/material/icon';
import { BreadcrumbsComponent, ButtonComponent, PageContainerComponent } from 'wecheer-common';
import { AppVersionService } from 'src/app/common/services/app-version.service';
import { AsyncPipe } from '@angular/common';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'app-safe-box-search',
    templateUrl: './safe-box-search.component.html',
    styleUrls: ['./safe-box-search.component.scss'],
    imports: [
        MatIconModule,
        PageContainerComponent,
        BreadcrumbsComponent,
        ButtonComponent,
        AsyncPipe
    ]
})

export class SafeBoxSearchComponent implements OnInit {
    screen = inject(ScreenService);
    appVersion = inject(AppVersionService);
    private dialog = inject(MatDialog);

    title = 'Safeboxes';

    ngOnInit() {
    }

    async add() {
        const config = {
            ...SafeBoxEditComponent.config,
        };
        await lastValueFrom(this.dialog.open(SafeBoxEditComponent, config).afterClosed());
    }

    async import() {
        const config = {
            ...SafeBoxImportComponent.config,
        };
        await lastValueFrom(this.dialog.open(SafeBoxImportComponent, config).afterClosed());
    }
}